<div class="user-request-stats">
    <div class="toolbar">
        <mat-button-toggle-group [value]="days" (change)="onPeriodChange($event.value)" aria-label="Période">
            @for (period of periods; track period) {
                <mat-button-toggle [value]="period">{{period}} jours</mat-button-toggle>
            }
        </mat-button-toggle-group>
        <mat-form-field class="canal" subscriptSizing="dynamic">
            <mat-label>Canal</mat-label>
            <mat-select [(ngModel)]="canal" (selectionChange)="onCanalChange()">
                <mat-option [value]="undefined">Tous</mat-option>
                @for (option of canalOptions; track option.value) {
                    <mat-option [value]="option.value">{{option.label}}</mat-option>
                }
            </mat-select>
        </mat-form-field>
        <mat-form-field class="search" subscriptSizing="dynamic">
            <mat-label>Rechercher un utilisateur, une agence</mat-label>
            <input matInput [(ngModel)]="search" (ngModelChange)="onSearchChange()">
            <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
    </div>

    <div class="table-wrapper">
        <table mat-table [dataSource]="filteredStats" class="pulpo-table w-100" matSort
            [matSortActive]="sort.active" [matSortDirection]="sort.direction" (matSortChange)="onSortChange($event)">
            <ng-container matColumnDef="requester">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Demandeur</th>
                <td mat-cell *matCellDef="let stat">
                    <div class="name">{{displayName(stat)}}</div>
                    @if (secondaryName(stat); as login) {
                        <div class="secondary">{{login}}</div>
                    }
                </td>
            </ng-container>
            <ng-container matColumnDef="groups">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Groupe / agence</th>
                <td mat-cell *matCellDef="let stat">{{stat.groups?.join(', ')}}</td>
            </ng-container>
            <ng-container matColumnDef="canal">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Canal</th>
                <td mat-cell *matCellDef="let stat">{{canalLabel(stat.canal)}}</td>
            </ng-container>
            <ng-container matColumnDef="list">
                <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before" class="count">List</th>
                <td mat-cell *matCellDef="let stat" class="count">
                    {{stat.listOk}}@if (stat.listKo) {<span class="ko" matTooltip="En erreur"> / {{stat.listKo}} KO</span>}
                </td>
            </ng-container>
            <ng-container matColumnDef="quote">
                <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before" class="count">Quote</th>
                <td mat-cell *matCellDef="let stat" class="count">
                    {{stat.quoteOk}}@if (stat.quoteKo) {<span class="ko" matTooltip="En erreur"> / {{stat.quoteKo}} KO</span>}
                </td>
            </ng-container>
            <ng-container matColumnDef="booking">
                <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before" class="count">Book</th>
                <td mat-cell *matCellDef="let stat" class="count">
                    <strong>{{stat.bookingOk}}</strong>@if (stat.bookingKo) {<span class="ko" matTooltip="En erreur"> / {{stat.bookingKo}} KO</span>}
                </td>
            </ng-container>
            <ng-container matColumnDef="lastRequestDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Dernière requête</th>
                <td mat-cell *matCellDef="let stat">{{stat.lastRequestDate | date: 'dd/MM/yy HH:mm'}}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="statColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let stat; columns: statColumns;" class="clickable" (click)="open(stat)"></tr>
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell empty" [attr.colspan]="statColumns.length">
                    {{loadingStats ? 'Chargement…' : 'Aucune requête sur la période'}}
                </td>
            </tr>
        </table>
    </div>
</div>
